// Pure helpers of the horizontal bar chart shared by "Por tipo de turno" (courts) and "Por servicio"
// (Beauty).

/**
 * Font size of the labels and values of the bars, in CSS pixels. The chart is made of HTML rows
 * (not an SVG with a viewBox), so the text keeps this size at any container width instead of
 * growing with it; it is applied inline so a test can guard it.
 */
export const BAR_TEXT_PX = 12;

// A positive value never draws thinner than this share of the track, so it stays visible.
const MIN_PERCENT = 2;

/**
 * Length of a bar as a percentage of the largest value (0..100). A value of zero (or less) is 0:
 * no bar at all, because a stub would read as money that is not there. The caller still shows the
 * value as text.
 */
export const barPercent = (value, max) => {
  if (!(value > 0) || !(max > 0)) return 0;
  return Math.max(MIN_PERCENT, (value / max) * 100);
};
